/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Master Digital Pharma Mailing Template Library API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { MailingMailTemplateOverviewResultsRestDto } from '../models';
import { MailingMailTemplateRestDto } from '../models';
/**
 * MailingMailTemplateApi - axios parameter creator
 * @export
 */
export const MailingMailTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint verantwoordelijk voor het promoveren van een Notification Template naar een Mailing Mail Template met extra metadata.
         * @summary REST.API.MMT.02 Promoot Notification Template naar Mailing Mail Template.
         * @param {MailingMailTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingMailTemplate: async (body: MailingMailTemplateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createMailingMailTemplate.');
            }
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling createMailingMailTemplate.');
            }
            const localVarPath = `/mailing_mail_template/v1/mailing_mail_template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API waarmee de Digital-Pharma Mailing Mail Templates gezocht kunnen worden binnen een specifieke bibliotheek.
         * @summary REST.API.MMT.01 Zoek Mailing Mail Template elementen.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} filter_library_code De unieke code van de bibliotheek waarin gezocht moet worden (bv. &#x27;DIGITAL_PHARMA&#x27;).
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMailingMailTemplates: async (x_dp_module_code: string, filter_library_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling findMailingMailTemplates.');
            }
            // verify required parameter 'filter_library_code' is not null or undefined
            if (filter_library_code === null || filter_library_code === undefined) {
                throw new RequiredError('filter_library_code','Required parameter filter_library_code was null or undefined when calling findMailingMailTemplates.');
            }
            const localVarPath = `/mailing_mail_template/v1/mailing_mail_template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (!!filter_library_code || typeof(filter_library_code) === "boolean") {
                localVarQueryParameter['filter_library_code'] = filter_library_code;
            }

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint verantwoordelijk voor het ophalen van het detail van een Mailing Mail Template.
         * @summary REST.API.MMT.05 Haal Mailing Mail Template detail op.
         * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingMailTemplate: async (id: string, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getMailingMailTemplate.');
            }
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling getMailingMailTemplate.');
            }
            const localVarPath = `/mailing_mail_template/v1/mailing_mail_template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint verantwoordelijk voor het wijzigen van de metadata van een Mailing Mail Template.
         * @summary REST.API.MMT.03 Wijzig Mailing Mail Template.
         * @param {MailingMailTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailingMailTemplate: async (body: MailingMailTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateMailingMailTemplate.');
            }
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling updateMailingMailTemplate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateMailingMailTemplate.');
            }
            const localVarPath = `/mailing_mail_template/v1/mailing_mail_template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailingMailTemplateApi - functional programming interface
 * @export
 */
export const MailingMailTemplateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * API endpoint verantwoordelijk voor het promoveren van een Notification Template naar een Mailing Mail Template met extra metadata.
         * @summary REST.API.MMT.02 Promoot Notification Template naar Mailing Mail Template.
         * @param {MailingMailTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMailingMailTemplate(_axios: AxiosInstance, body: MailingMailTemplateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MailingMailTemplateApiAxiosParamCreator(configuration).createMailingMailTemplate(body, x_dp_module_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API waarmee de Digital-Pharma Mailing Mail Templates gezocht kunnen worden binnen een specifieke bibliotheek.
         * @summary REST.API.MMT.01 Zoek Mailing Mail Template elementen.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} filter_library_code De unieke code van de bibliotheek waarin gezocht moet worden (bv. &#x27;DIGITAL_PHARMA&#x27;).
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMailingMailTemplates(_axios: AxiosInstance, x_dp_module_code: string, filter_library_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailingMailTemplateOverviewResultsRestDto>> {
            const localVarAxiosArgs = await MailingMailTemplateApiAxiosParamCreator(configuration).findMailingMailTemplates(x_dp_module_code, filter_library_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API endpoint verantwoordelijk voor het ophalen van het detail van een Mailing Mail Template.
         * @summary REST.API.MMT.05 Haal Mailing Mail Template detail op.
         * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailingMailTemplate(_axios: AxiosInstance, id: string, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailingMailTemplateRestDto>> {
            const localVarAxiosArgs = await MailingMailTemplateApiAxiosParamCreator(configuration).getMailingMailTemplate(id, x_dp_module_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API endpoint verantwoordelijk voor het wijzigen van de metadata van een Mailing Mail Template.
         * @summary REST.API.MMT.03 Wijzig Mailing Mail Template.
         * @param {MailingMailTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which language the content is expected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMailingMailTemplate(_axios: AxiosInstance, body: MailingMailTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MailingMailTemplateApiAxiosParamCreator(configuration).updateMailingMailTemplate(body, x_dp_module_code, id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MailingMailTemplateApi - object-oriented interface
 * @export
 * @class MailingMailTemplateApi
 * @extends {BaseAPI}
 */
export class MailingMailTemplateApi extends BaseAPI {
    /**
     * API endpoint verantwoordelijk voor het promoveren van een Notification Template naar een Mailing Mail Template met extra metadata.
     * @summary REST.API.MMT.02 Promoot Notification Template naar Mailing Mail Template.
     * @param {MailingMailTemplateRestDto} body 
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which language the content is expected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingMailTemplateApi
     */
     public createMailingMailTemplate(body: MailingMailTemplateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return MailingMailTemplateApiFp(this.configuration).createMailingMailTemplate(this.axios, body, x_dp_module_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API waarmee de Digital-Pharma Mailing Mail Templates gezocht kunnen worden binnen een specifieke bibliotheek.
     * @summary REST.API.MMT.01 Zoek Mailing Mail Template elementen.
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} filter_library_code De unieke code van de bibliotheek waarin gezocht moet worden (bv. &#x27;DIGITAL_PHARMA&#x27;).
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which language the content is expected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingMailTemplateApi
     */
     public findMailingMailTemplates(x_dp_module_code: string, filter_library_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return MailingMailTemplateApiFp(this.configuration).findMailingMailTemplates(this.axios, x_dp_module_code, filter_library_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint verantwoordelijk voor het ophalen van het detail van een Mailing Mail Template.
     * @summary REST.API.MMT.05 Haal Mailing Mail Template detail op.
     * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which language the content is expected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingMailTemplateApi
     */
     public getMailingMailTemplate(id: string, x_dp_module_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return MailingMailTemplateApiFp(this.configuration).getMailingMailTemplate(this.axios, id, x_dp_module_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint verantwoordelijk voor het wijzigen van de metadata van een Mailing Mail Template.
     * @summary REST.API.MMT.03 Wijzig Mailing Mail Template.
     * @param {MailingMailTemplateRestDto} body 
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} id De unieke identificatie (UUID) van de Mailing Mail Template.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which language the content is expected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingMailTemplateApi
     */
     public updateMailingMailTemplate(body: MailingMailTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return MailingMailTemplateApiFp(this.configuration).updateMailingMailTemplate(this.axios, body, x_dp_module_code, id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
